export default __webpack_public_path__ + "static/media/activeOrder.7b39568d.svg";